import Vue from 'vue';

const errorState = Vue.observable({ errors: [] });

const AppErrorService = {
  getErrorsState() {
    return errorState;
  },
  addError(error) {
    errorState.errors.push(error);
  },
  removeError(removeError) {
    errorState.errors = errorState.errors.filter(error => error !== removeError);
  }
};

export { AppErrorService };
